import { render, staticRenderFns } from "./BaseInputPhoneNumber.vue?vue&type=template&id=97057dd0&"
import script from "./BaseInputPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./BaseInputPhoneNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports